import { trackMobileCustomEventsAU } from "../../../tracking";
import { AU_MOBILE_EVENTS } from "../../../tracking/au.mobile-events";

export const trackHomePageEvent = (eventAction, eventLabel = "NA") => {
    trackMobileCustomEventsAU(AU_MOBILE_EVENTS.CARS24_HOMEPAGE, {eventAction, eventLabel});
};
